// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__3J1q3","text":"Textarea_text__0UkOy"};